"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledQuestions = exports.StyledQASummary = exports.StyledAnswers = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var _default = {};
exports["default"] = _default;

var StyledAnswers = _styledComponents["default"].section.withConfig({
  displayName: "QuestionsAndAnswersstyles__StyledAnswers",
  componentId: "sc-bczp21-0"
})(["", " & > span{", "}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["f4 pl2 pv2"]))), (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["b"]))));

exports.StyledAnswers = StyledAnswers;

var StyledQASummary = _styledComponents["default"].section.withConfig({
  displayName: "QuestionsAndAnswersstyles__StyledQASummary",
  componentId: "sc-bczp21-1"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["w-100 flex justify-center tc pv4"]))));

exports.StyledQASummary = StyledQASummary;

var StyledQuestions = _styledComponents["default"].section.withConfig({
  displayName: "QuestionsAndAnswersstyles__StyledQuestions",
  componentId: "sc-bczp21-2"
})(["", " & > span{", "}"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["f4 pb1 br b--gray pr2 pv2"]))), (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["b"]))));

exports.StyledQuestions = StyledQuestions;